<app-push-text-button-v2-atom
  [heading]="heading"
  [text]="text"
  [buttonLabel]="buttonLabel"
  [imageUrl]="icon?.url"
  [backgroundColor]="backgroundColor"
  (buttonClick)="buttonClick($event)"
></app-push-text-button-v2-atom>
